import { SwenLogo } from "@/components/Icons/SwenLogo.tsx";
import { cleanHomeURL } from "@/components/Logo/cleanHomeURL.ts";
import { useGetOrganization } from "@/helpers/useGetOrganization.tsx";
import { useEngineStore } from "@/stores/EngineStore/EngineStore.ts";
import { AppPage } from "@/stores/EngineStore/enums/AppPage.ts";
import { useShallow } from "zustand/react/shallow";

export const Logo = ({ className }: { className?: string }) => {
  const { setPage } = useEngineStore(useShallow((state) => ({ setPage: state.setPage })));
  const { logoUrl } = useGetOrganization();

  return (
    <div className={className ? `c-logo ${className}` : "c-logo"}>
      <button
        className="c-logo__link"
        onClick={() => {
          cleanHomeURL();
          setPage(AppPage.AccommodationPicking, "replace");
        }}
      >
        {logoUrl ? (
          <img src={logoUrl} alt={"logo"} style={{ maxWidth: 200, maxHeight: 100 }} />
        ) : (
          <SwenLogo />
        )}
      </button>
    </div>
  );
};
